import React, { useState, useEffect, useCallback } from 'react'
import Emitter from '@utils/eventEmitter'
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText
} from '@mui/material'


const Confirm = () => {
	const [ show, setShow ] = useState(false)
	const [ text, setText ] = useState('')
	const [ buttonTexts, setButtonTexts ] = useState(['예', '아니오'])
	const [ successCb, setSuccessCb ] = useState(null)
	const [ cancelCb, setCancelCb ] = useState(null)

	const hideConfirm = () => {
		setShow(false)
		setText('')
		setButtonTexts(['예', '아니오'])
		setSuccessCb(null)
		setCancelCb(null)
	}

	const showConfirm = useCallback(({ show, text, buttonTexts, successCb, cancelCb }) => {
		setText(text || '')
		setButtonTexts(buttonTexts || ['예', '아니오'])
		setShow(true)
		setSuccessCb(() => { return successCb })
		setCancelCb(() => { return (cancelCb || hideConfirm) })
	}, [])

	useEffect(() => {
		Emitter.on('SHOW_CONFIRM', showConfirm)
		Emitter.on('HIDE_CONFIRM', hideConfirm)
		return () => {
			Emitter.off('SHOW_CONFIRM')
			Emitter.off('HIDE_CONFIRM')
		}
	}, [ showConfirm ])

	return (
		<>
			{
				show ?  <Dialog
					maxWidth={'xs'}
	        open={show}
	        fullWidth={true}
	        onClose={hideConfirm}
	      >
	        <DialogContent>
	          <DialogContentText>{text}</DialogContentText>
	        </DialogContent>
	        <DialogActions>
	          <Button variant="contained" onClick={successCb} disableElevation>{buttonTexts[0]}</Button>
	          <Button variant="outlined" onClick={cancelCb}>{buttonTexts[1]}</Button>
	        </DialogActions>
	      </Dialog> : ''
			}
		</>
	)

}

export default Confirm